export function imageUrl2Base64(imgUrl) {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = () => {
      const canvas = document.createElement('canvas')
      const width = (canvas.width = image.width)
      const height = (canvas.height = image.height)
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, width, height)
      resolve(canvas.toDataURL('image/jpg'))
      image = null
    }
    image.onerror = () => {
      reject(new Error('图片加载失败'))
      image = null
    }
    image.src = imgUrl
  })
}

export function isBase64(str) {
  return /^data:image\/[a-z]+;base64,/.test(str)
}

export async function downloadImageByUrl(imgUrl, filename = '小程序二维码', ext = 'jpeg') {
  let anchor = document.createElement('a')
  const event = new MouseEvent('click')
  anchor.href = isBase64(imgUrl) ? imgUrl : await imageUrl2Base64(imgUrl)
  anchor.download = `${filename}.${ext}`
  anchor.dispatchEvent(event)
  anchor = null
}

export function downloadFileByUrl(fileUrl, fileName) {
  let anchor = document.createElement('a')
  const event = new MouseEvent('click')
  anchor.href = fileUrl
  anchor.download = fileName
  anchor.dispatchEvent(event)
  anchor = null
}
